import { useCallback, useState } from 'react';
import type { ListingMapCatalogSync } from './listing-map';

export function useListingMapCatalog(current: ListingMapCatalogSync, isSettled: boolean, scope: string) {
  const [previous, setPrevious] = useState<{ catalog: ListingMapCatalogSync; scope: string }>();
  // Capture the accepted catalog in the viewport event, before starting its replacement query.
  const preserveCatalog = useCallback(() => {
    if (!isSettled) return;
    setPrevious((value) => (value?.catalog === current && value.scope === scope ? value : { catalog: current, scope }));
  }, [current, isSettled, scope]);

  const catalog = isSettled ? current : previous?.scope === scope ? previous.catalog : undefined;
  return { catalog, preserveCatalog };
}
